import { u as t } from "./index-Yn8c3UWE.js";
import { u as c, a as m, b as n } from "./index-Czzd9rjU.js";
const p = () => {
  const a = c(), s = m(), [o, r] = t(), e = n();
  return { location: a, navigate: s, params: e, searchParams: o, setSearchParams: r };
};
export {
  p as u
};
//# sourceMappingURL=useExposedProps-CTPtylCV.js.map
